import { Link } from 'react-router-dom';
import '../styling/global.css';
import img from '../assets/footer_icon.png';
import map from '../assets/map.png';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

const servicesData = [
  {
    id: 1,
    title: 'AI & Data Services'
  },
  {
    id: 2,
    title: 'Data Annotation & Dataset Solutions'
  },
  {
    id: 3,
    title: 'AI Training Dataset Development'
  },
  {
    id: 4,
    title: 'Testing & Quality Assurance'
  },
  {
    id: 5,
    title: 'App & Web Development'
  },
  {
    id: 6,
    title: 'Creative & Graphic Design Services'
  }
];

const Footer = () => {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-brand">
          <img src={img} alt="website_logo" className="footer-image" />
          <p>
            JSK Technologies provides cutting-edge IT solutions and services to help businesses thrive in
            the digital world through innovation and technology excellence.
          </p>
        </div>

        <div className="footer-links">
          <div className='quick-links'>
            <h4 className='heading1'>Quick Links</h4>
            <ul>
              <li><Link to="/" onClick={scrollToTop}>Home</Link></li>
              <li><Link to="/about-us" onClick={scrollToTop}>About Us</Link></li>
              <li><Link to="/services" onClick={scrollToTop}>Services</Link></li>
              <li><Link to="/products" onClick={scrollToTop}>Products</Link></li>
              <li><Link to="/careers" onClick={scrollToTop}>Careers</Link></li>
              <li><Link to="/contact-us" onClick={scrollToTop}>Contact Us</Link></li>
            </ul>
          </div>

          <div className="services-container">
            <h4 className='heading'>Our Services</h4>
            <ul className="services-list">
              {servicesData.map((service) => (
                <li
                  key={service.id}
                  className="service-item"
                >
                  <Link 
                    to={`/services/section/${service.id}`} 
                    className="service-link"
                    onClick={scrollToTop}
                  >
                    {service.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className='address'>
            <h4 className='heading1'>Reach us</h4>
            <p>
              <FaPhoneAlt style={{ marginRight: "8px",color: "#ffffff" }} />
              <a href="tel:+919676362000">+91 9676362000</a>
            </p>
            <p>
              <FaEnvelope style={{ marginRight: "8px", color: "#ffffff" }} />
              <a href="mailto:info@jsktechnologies.in">info@jsktechnologies.in</a>
            </p>
            <p>
              <FaMapMarkerAlt style={{ marginRight: "8px",color: "#ffffff"  }} />
              <a
                href="https://maps.app.goo.gl/mzKJx5EnYcSPMjit9"
                target="_blank"
                rel="noopener noreferrer"
              >
                59A-15-29, Roadno4 Nagar, NTR Circle, Patamata, Vijayawada, AP 520010
              </a>
            </p>
            <a
              href="https://maps.app.goo.gl/mzKJx5EnYcSPMjit9"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={map} alt="map" className="map-image" />
            </a>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        © {new Date().getFullYear()} JSK Technologies. All Rights Reserved.
        <div className="policies">
          <Link to="/privacy-policy">Privacy Policy</Link> |
          <Link to="/terms">Terms</Link> |
          <Link to="/cookies">Cookies</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;